import ApplicationController from "./application_controller";
import * as moment from 'moment/moment.js'

export default class extends ApplicationController {
  static targets = [ "installments", "total", "balance", "installmentsLeft", "installmentAmount"]
  static values = { paid: String, deposit: String, installmentsPaid: Number }

  calculate() {
    this.balance = this.total - this.paid - this.deposit
    this.installmentsLeft = this.installments - this.installmentsPaid

    let installmentAmount = this.balance / this.installmentsLeft

    this.installmentAmount = installmentAmount < 0 ? 0 : installmentAmount
  }

  mask(value) {
    return Inputmask({ alias: 'currency', radixPoint: ',' }).format(value)
  }

  get installments() {
    return this.installmentsTarget.value
  }

  get installmentsPaid() {
    return this.installmentsPaidValue
  }

  get paid() {
    return this.unmask(this.paidValue)
  }

  get deposit() {
    return this.unmask(this.depositValue)
  }

  get total() {
    return this.unmask(this.totalTarget.value)
  }

  get balance() {
    return this.unmask(this.balanceTarget.value)
  }

  set balance(value) {
    this.balanceTarget.value = this.mask(value)
  }

  get installmentsLeft() {
    return this.installmentsLeftTarget.innerHTML
  }

  set installmentsLeft(value) {
    this.installmentsLeftTarget.innerHTML = value
  }

  set installmentAmount(value) {
    this.installmentAmountTarget.value = this.mask(value)
  }
}
